import { HUB_FILTERS } from './stationAdapter';

const fmt = (n) => (typeof n === 'number' ? n.toLocaleString('en-US') : '…');

/** Hub-type filter chips with counts; behaves as a single-choice radio group. */
export default function HubFilterChips({ value, counts, onChange }) {
  const visible = HUB_FILTERS.filter((h) => !h.hideWhenEmpty || (counts?.[h.key] ?? 0) > 0);
  return (
    <div role="radiogroup" aria-label="Filter by hub type" className="flex flex-wrap gap-2">
      {visible.map((hub) => {
        const active = value === hub.key;
        return (
          <button
            key={hub.key}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => !active && onChange(hub.key)}
            className={`h-8 px-3 rounded-full text-xs font-semibold inline-flex items-center gap-1.5 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-status-ok-dot focus-visible:ring-offset-1 ${
              active ? 'bg-primary text-on-primary' : 'bg-surface-container-low text-on-surface-variant hover:bg-surface-container hover:text-on-surface'
            }`}
          >
            {hub.dot && <span className={`w-2 h-2 rounded-full ${hub.dot}`} aria-hidden="true" />}
            {hub.label}
            <span
              className={`px-1.5 rounded-full text-[10px] font-data-mono ${
                active ? 'bg-primary-container text-on-primary-container' : 'text-on-surface-variant'
              }`}
            >
              {fmt(counts?.[hub.key])}
            </span>
          </button>
        );
      })}
    </div>
  );
}
